<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" :hide-details="true" />
        </div>

        <SectionLayout :settings="fields.settings" :container-page="fields.containerPage" />

        <div class="mb-5">
          <label class="label-input">Title Section</label>
          <div class="group-item">
            <v-checkbox v-model="fields['title-card'].show" label="Show title block" hide-details class="mt-0 mb-2" />
            <ckeditor
              v-if="fields['title-card'].show"
              :editor="editor"
              v-model="fields['title-card'].content"
              :config="editorConfig"
            />
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Banner Images</label>
          <v-row>
            <v-col cols="12" md="6">
              <UploadImage
                @callback="obj => (fields['image-banner-left'] = obj.imageSrc)"
                :image="{ imageSrc: fields['image-banner-left'] }"
                :height="`180`"
                :typeUpload="'image'"
                @callbackDelete="fields['image-banner-left'] = ''"
              />
              <span class="caption">Banner left</span>
              <v-text-field v-model="fields['image-banner-left-link']" :hide-details="true" class="mt-2" />
            </v-col>
            <v-col cols="12" md="6">
              <UploadImage
                @callback="obj => (fields['image-banner-right'] = obj.imageSrc)"
                :image="{ imageSrc: fields['image-banner-right'] }"
                :height="`180`"
                :typeUpload="'image'"
                @callbackDelete="fields['image-banner-right'] = ''"
              />
              <span class="caption">Banner right</span>
              <v-text-field v-model="fields['image-banner-right-link']" :hide-details="true" class="mt-2" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-7">
          <div class="label-input">Slider Items</div>
          <div class="group-item">
            <div>
              <v-checkbox v-model="fields['show-slider']" label="Show slider" :hide-details="true" class="mb-2" />
            </div>
            <div class="d-flex justify-space-between align-center">
              <label style="margin-bottom: 0"></label>
              <v-btn small color="primary" @click="handleAddItem">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields['list-item']" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Item {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <UploadImage
                    @callback="obj => handleUploadImage(obj, i)"
                    :image="{ imageSrc: item.image }"
                    :height="`180`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveUpload(i)"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import SectionLayout from '../common/ui-modules/section-layout/editor.vue';

const getDefaultFields = () => ({
  title: 'Grid Item Kynorelle Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useCustomWidth: false,
    customWidth: 1204,
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  'show-slider': false,
  'title-card': {
    show: false,
    content: '<h2><strong>Feels Light</strong></h2><p>Soft fabric you can wear all day without noticing.</p>',
  },
  'image-banner-left': '',
  'image-banner-left-link': '',
  'image-banner-right': '',
  'image-banner-right-link': '',
  'list-item': [],
});

export default {
  name: 'GridItemKynorelleSectionEditor',
  components: {
    UploadImage,
    SectionLayout,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const def = getDefaultFields();
    const sectionExtract = cloneDeep(this.sectionEditor.sectionExtract || {});
    this.fields = {
      ...def,
      ...sectionExtract,
      settings: {
        ...def.settings,
        ...(sectionExtract.settings || {}),
      },
      containerPage: {
        ...def.containerPage,
        ...(sectionExtract.containerPage || {}),
      },
      'title-card': {
        ...def['title-card'],
        ...(sectionExtract['title-card'] || {}),
      },
      'list-item':
        sectionExtract['list-item'] && sectionExtract['list-item'].length
          ? sectionExtract['list-item'].map(item => ({ image: item.image || '' }))
          : [{ image: '' }],
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionGridItemKynorelle(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj, i) {
      this.fields['list-item'][i].image = obj.imageSrc;
    },
    handleRemoveUpload(i) {
      this.fields['list-item'][i].image = '';
    },
    handleAddItem() {
      this.fields['list-item'].push({
        image: '',
      });
    },
    handleRemoveItem(i) {
      // if (this.fields['list-item'].length <= 1) return;
      this.fields['list-item'].splice(i, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.ck-editor__editable_inline {
  min-height: 200px;
}
.ck-editor__editable {
  min-height: 200px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.caption {
  font-size: 12px;
  color: #666;
  display: block;
  margin-top: 4px;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
